/** Claves centralizadas para el almacenamiento local. */
export const STORAGE_KEYS = {
  accessToken: 'geoliftec.accessToken',
  refreshToken: 'geoliftec.refreshToken',
  session: 'geoliftec.session',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
